import { toDate } from 'helpers/dateHelper'
import { Button, Card, CardContent, IconButton, InputAdornment, Menu, MenuItem, Select, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useState } from 'react';
import { FaComments, FaUnlink, FaUserCircle } from 'react-icons/fa';
import CustomersAutocompleteField from 'components/CustomersAutocomplete/CustomersAutocomplete';
import { LeadEvents } from './LeadEvents';
import { Link, useNavigate } from 'react-router-dom';

export interface LeadMainInfoV2Props {
    lead: any
    deleteCustomerFromLead: (customerID: string) => void
    addCustomerToLead: (customer: any) => void
}
export const LeadMainInfoV2 = ({ lead, deleteCustomerFromLead, addCustomerToLead }: LeadMainInfoV2Props) => {
    const { control, setValue, watch, getValues } = useFormContext();
    const navigate = useNavigate();

    const [moreOptionsAnchorEl, setMoreOptionsAnchorEl] = useState<null | HTMLElement>(null);

    const handleCreateNewContact = () => {
        setMoreOptionsAnchorEl(null)
    }

    const selectCustomer = (customer: any) => {
        addCustomerToLead(customer)
        setMoreOptionsAnchorEl(null)
    }

    const buildCreatedByInfo = () => {
        if (lead?.createdByType === 'AUTOMATION') {
            return <div className='flex gap-2 items-center'>
                <span className='flex-[0.3]'>Кем создана</span>
                <span className='flex-[0.7]'>
                    <Link to={`/admin/automations/create/constructor/${lead?.createdByID}`}>[{lead?.createdByType}]: <span className='text-blue-500'>{lead?.createdByName}</span></Link>
                </span>
            </div>
        }

        if (lead?.createdByType === 'MEMBER') {
            return <div className='flex gap-2 items-center'>
                <span className='flex-[0.3]'>Кем создана</span>
                <span className='flex-[0.7]'>
                    <Link to={`/admin/members/${lead?.createdByID}`}>[{lead?.createdByType}]: <span className='text-blue-500'>{lead?.createdByName}</span></Link>
                </span>
            </div>
        }

        if (lead?.createdByType === 'USER') {
            return <div className='flex gap-2 items-center'>
                <span className='flex-[0.3]'>Кем создана</span>
                <span className='flex-[0.7]'>
                    <Link to={`/admin/users/${lead?.createdByID}`}>[{lead?.createdByType}]: <span className='text-blue-500'>{lead?.createdByName}</span></Link>
                </span>
            </div>
        }

        if (lead?.createdByType === 'SYSTEM') {
            return <div className='flex gap-2 items-center'>
                <span className='flex-[0.3]'>Кем создана</span>
                <span className='flex-[0.7]'>
                    [{lead?.createdByType}]: <span className='text-blue-500'>{lead?.createdByName}</span>
                </span>
            </div>
        }
        return null
    }

    return (
        <section className='lead-main flex flex-space-between gap-4'>
            <div className='lead-main-left flex-1'>
                <div className='lead-main-info gap-4 flex flex-col mt-4'>
                    <div className='flex gap-2 flex items-center'>
                        <span className='flex-[0.3]'>Создана</span>
                        <span className='flex-[0.7]'>{toDate(lead?.createdAt)}</span>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <span className='flex-[0.3]'>Ответственный</span>
                        <span className='flex-[0.7]'>{lead?.manager?.name}</span>
                    </div>
                    {/* Кем создана */}
                    {buildCreatedByInfo()}
                    <div className='flex gap-2 items-center'>
                        <span className='flex-[0.3]'>Бюджет</span>
                        <span className='flex-[0.7]'>
                            <TextField
                                size='small'
                                variant='outlined'
                                fullWidth
                                type='text'
                                value={watch('budget')}
                                onChange={(e) => setValue('budget', e.target.value || '')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                style={{
                                    marginRight: 0,
                                    paddingRight: 0,
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position='end'>
                                        <Select
                                            variant='standard'
                                            value={watch('currency')}
                                            onChange={(e) => setValue('currency', String(e.target.value))}
                                            disableUnderline
                                            sx={{
                                                minWidth: 70,
                                                '& .MuiSelect-select': {
                                                    padding: '0 8px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                },
                                            }}
                                        >
                                            <MenuItem value="KZT">KZT</MenuItem>
                                            <MenuItem value="USD">USD</MenuItem>
                                            <MenuItem value="EUR">EUR</MenuItem>
                                        </Select>
                                    </InputAdornment>
                                }}
                            />
                        </span>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <span className='flex-[0.3]'>Тип сделки</span>
                        <div className='flex-[0.7]'>
                            <Controller
                                control={control}
                                name='type'
                                render={({ field }: any) => (
                                    <Select size='small' variant='outlined' fullWidth {...field} value={watch('type')} onChange={(e) => setValue('type', String(e.target.value))}>
                                        <MenuItem value="sale_products">Продажа товаров</MenuItem>
                                        <MenuItem value="other_sale">Прочее</MenuItem>
                                    </Select>
                                )}
                            />
                        </div>
                    </div>

                    {/* Contacts */}
                    <div className='flex flex-col gap-2 mt-4'>
                        <div className='contact-header flex flex-space-between items-center w-full'>
                            <div className='flex items-center gap-2'>
                                <FaUserCircle size={16} />
                                <span>Клиент</span>
                            </div>
                            <div>
                                <div className='text-blue-500 cursor-pointer'
                                    onClick={(e) => setMoreOptionsAnchorEl(e.currentTarget)}>
                                    + Добавить клиента
                                </div>
                                <Menu
                                    anchorEl={moreOptionsAnchorEl}
                                    open={Boolean(moreOptionsAnchorEl)}
                                    onClose={() => setMoreOptionsAnchorEl(null)}>
                                    <div className='p-2' style={{
                                        width: 300,
                                        height: 200,
                                    }}>
                                        <CustomersAutocompleteField label="Покупатель" setValue={(v: any) => selectCustomer(v)} />
                                        <div className='mt-12'>
                                            <Button variant="outlined" fullWidth color="primary" onClick={handleCreateNewContact}>
                                                + Создать новый покупатель
                                            </Button>
                                        </div>
                                    </div>
                                </Menu>
                            </div>
                        </div>
                        <div className='contacts-list flex flex-col gap-2 mt-2'>
                            {getValues('customers')?.map((customer: any) => (
                                <Card key={customer?.id} className='customer-item'>
                                    <CardContent>
                                        <div className='flex items-center gap-2'>
                                            <div className='contact-header flex flex-space-between items-center w-full'>
                                                <Link target='_blank' to={`/admin/customers/view/${customer?.id}`}>{(customer?.lastName || '') + ' ' + (customer?.firstName || '') || customer?.id}</Link>
                                                <div>
                                                    {/* Перейти к чату */}
                                                    <IconButton color="info" onClick={() => navigate(`/admin/chats?query=${customer?.firstName}`)}>
                                                        <FaComments size={16} />
                                                    </IconButton>
                                                    <IconButton color="info" onClick={() => deleteCustomerFromLead(customer?.id)}>
                                                        <FaUnlink size={16} />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='lead-main-right flex-1'>
                {/* Comment form */}
                {/* Events */}
                <LeadEvents leadID={lead?.id} />
            </div>
        </section>
    )
}
